import React from 'react'
import Link from 'next/link'
import { User, ChevronRight } from 'lucide-react'

export const TrainerCard = ({ trainer }) => {
    if (!trainer) return null

    return (
        <Link
            href={`/profile/${trainer.handleName}`}
            className="flex items-center gap-3 p-3 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer"
        >
            {trainer.profilePicture ? (
                <img
                    src={trainer.profilePicture}
                    alt={trainer.firstName}
                    className="w-10 h-10 rounded-full object-cover border-2 border-white shadow-sm"
                />
            ) : (
                <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center">
                    <User size={18} className="text-indigo-500" />
                </div>
            )}
            <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-gray-900 truncate">
                    {trainer.firstName} {trainer.lastName}
                </p>
                {trainer.handleName && (
                    <p className="text-xs text-indigo-500">@{trainer.handleName}</p>
                )}
            </div>
            <ChevronRight size={16} className="text-gray-400 shrink-0" />
        </Link>
    )
}
